export default __webpack_public_path__ + "static/7-f6a5e5dbd0155ff3bf2c15a3c9089092.png";